import {
  EVALUATION_STATE_LIST, 
  EVALUATION_STATE_LIST_SUCCESS, 
  EVALUATION_STATE_LIST_ERROR,
  EVALUATION_STATE_SEARCH_SET, 
  EVALUATION_STATE_SEARCH_CHANGE, 
  EVALUATION_STATE_PAGE_SET,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_SUCCESS,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR,
  EVALUATION_STATE_ADD_SET,
  EVALUATION_STATE_ADD_MODAL_SET,
  EVALUATION_STATE_ADD,
  EVALUATION_STATE_ADD_SUCCESS,
  EVALUATION_STATE_ADD_ERROR,
  EVALUATION_STATE_ADD_CHANGE,
  EVALUATION_STATE_DETAIL,
  EVALUATION_STATE_DETAIL_SUCCESS,
  EVALUATION_STATE_DETAIL_ERROR,
  EVALUATION_STATE_VIEW_MODAL_SET,
  EVALUATION_STATE_EDIT_CHANGE,
  EVALUATION_STATE_EDIT_MODAL_SET,
  EVALUATION_STATE_UPDATE,
  EVALUATION_STATE_UPDATE_SUCCESS,
  EVALUATION_STATE_UPDATE_ERROR,
  EVALUATION_STATE_VIEW_TAB_SET,
  EVALUATION_STATE_UPLOAD_SET,
  EVALUATION_STATE_UPLOAD_SET_SUCCESS,
  EVALUATION_STATE_UPLOAD_SET_ERROR,
  EVALUATION_STATE_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ id_assessment: null, assessment: null, code: '', name: '', description: '', url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      assessment: false
    },
    value:{
      assessment: false,
    },
    assessment:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EVALUATION_STATE_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EVALUATION_STATE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EVALUATION_STATE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EVALUATION_STATE_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EVALUATION_STATE_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EVALUATION_STATE_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EVALUATION_STATE_SEARCH_ASSESSMENT_LIST:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment:{
            ...state.search.assessment,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EVALUATION_STATE_SEARCH_ASSESSMENT_LIST_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EVALUATION_STATE_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EVALUATION_STATE_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EVALUATION_STATE_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_assessment: null, assessment: null, code: '', name: '', description: '',  url_file: '', original_file_name: '', file_name: ''}
          },
          modal: action.payload
        }
      }
    case EVALUATION_STATE_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EVALUATION_STATE_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EVALUATION_STATE_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EVALUATION_STATE_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case EVALUATION_STATE_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EVALUATION_STATE_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case EVALUATION_STATE_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EVALUATION_STATE_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EVALUATION_STATE_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EVALUATION_STATE_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EVALUATION_STATE_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EVALUATION_STATE_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EVALUATION_STATE_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case EVALUATION_STATE_UPLOAD_SET:
      return { ...state };
    case EVALUATION_STATE_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case EVALUATION_STATE_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case EVALUATION_STATE_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};